// Formata quantidade de estoque conforme a unidade do produto:
// unidade que fraciona (LT, KG, MT...) mostra 3 casas decimais;
// unidade inteira (UN, CX, PC...) mostra número inteiro.
export const fmtQtd = (v, fraciona = false) =>
  Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: fraciona ? 3 : 0,
    maximumFractionDigits: fraciona ? 3 : 0,
  });
